import React from "react";
import { Collapse, Typography } from "antd";
import { SmallDashOutlined } from "@ant-design/icons";

import "./index.css";

export interface List {
  title: string;
  link?: string;
  children?: List[];
}

interface Props {
  list: List[];
}

const renderRecursive = (data: List[] | undefined): JSX.Element => {
  return (
    <ul>
      {data?.map((list: List) => {
        return (
          <li key={list.title}>
            <a href={`#${list.title}`}>
              <SmallDashOutlined /> {list.title}
            </a>
            {renderRecursive(list.children)}
          </li>
        );
      })}
    </ul>
  );
};

const { Text } = Typography;
export const IndexList = (props: Props) => {
  return (
    <div className="index-list">
      <Collapse ghost>
        <Collapse.Panel key="index" header={<Text strong>目次</Text>}>
          {renderRecursive(props.list)}
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default IndexList;
